import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'member-stats/leads'
    return Api.getInstance().request.get(`${path}?types=views,posts,cvs&group=weekly&range=30`, path)
}
